<template>
  <NuxtPage />
  <Loading />
</template>

<script setup>
  // Defaultno trajanje tranzicije je 250ms, može se promjeniti u composableu useSetup
  const { get, isWebsiteInited } = usePage()
  try {
    const { init } = useSetup()
    const { setLanguage } = useLanguage()
    
    await setLanguage()
    await init()
  } catch (e) {
    console.dir(e)
    throw createError({
      statusCode: 500,
      statusMessage: 'Failed to get setup script'
    })
  }

  await get()
  useNuxtApp().hook('page:finish', () => {
    if (!isWebsiteInited.value) isWebsiteInited.value = true
  })
</script>
